/* jshint ignore:start */

jQuery(document).ready(function () {
  var controller = new ScrollMagic.Controller();

  var projects = Array.prototype.slice.call(
    document.querySelectorAll(".two-col-parallax")
  );

  var self = this;

  projects.forEach(function (self) {
    var image = self.querySelectorAll("img");
    var text = self.querySelectorAll("p");

    var sceneOne = new TimelineMax();

    sceneOne
      .fromTo(image, 0.5, { y: 70 }, { y: -70 }, image);

    var scene1 = new ScrollMagic.Scene({
      triggerElement: self,
      triggerHook: "onEnter",
      duration: 5000,
      offset: 0
    })
      .setTween(sceneOne)
      .setClassToggle(self, "active")
      .addTo(controller);
  });


  // Footer fade in.
  var footer = Array.prototype.slice.call(
    document.querySelectorAll(".footer")
  );

  var f = jQuery('.footer'), cta = jQuery('.footer .call-to-action'), h = window.innerHeight;
  f.css('height', h);
  cta.css('height', h);

  var animation_height = Math.floor(h / 2) * -1;

  footer.forEach(function(self) {
    var text = self.querySelectorAll(".call-to-action");
    var sceneOne = new TimelineMax();
    sceneOne.fromTo(text, 1, { y: animation_height }, { y: 0, ease: Linear.easeNone });

    var scene1 = new ScrollMagic.Scene({
      triggerElement: '.footer',
      triggerHook: "onEnter",
      duration: h,//'100%',
      triggerHook: 1,
      offset: 0
    }) //.setPin('.footer', {pushFollowers: false})
      .setTween(sceneOne)
      .addTo(controller);
  });

});
